<app-loading></app-loading>
<router-outlet></router-outlet>
<footer class="text-center text-xs text-gray-500 mb-10">
    <p> © 2026 Fina Gastos | v{{ version }}
        <br> Desarrollado por
        Lautaro y Tomás Luna
        <br> <a href="/privacy-policy">Política de Privacidad</a>
    </p>
</footer>